var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { id: "email-enabled", color: "primary", label: "" },
                model: {
                  value: _vm.isEmailEnabled,
                  callback: function ($$v) {
                    _vm.isEmailEnabled = $$v
                  },
                  expression: "isEmailEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(_vm._s(_vm.$t("admin.enable_email")) + "\n    "),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "email-from-address",
              label: _vm.$t("admin.email_from_address"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "text",
              lazy: "true",
            },
            model: {
              value: _vm.emailFromAddress,
              callback: function ($$v) {
                _vm.emailFromAddress = $$v
              },
              expression: "emailFromAddress",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "email-prefix",
              label: _vm.$t("admin.email_prefix"),
              "input-group-size": "mb-3",
              type: "text",
              lazy: "true",
            },
            model: {
              value: _vm.emailPrefix,
              callback: function ($$v) {
                _vm.emailPrefix = $$v
              },
              expression: "emailPrefix",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "email-smtp-server",
              label: _vm.$t("admin.email_smtp_server"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "text",
              lazy: "true",
            },
            model: {
              value: _vm.emailSmtpServer,
              callback: function ($$v) {
                _vm.emailSmtpServer = $$v
              },
              expression: "emailSmtpServer",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "email-smtp-port",
              label: _vm.$t("admin.email_smtp_port"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "number",
              lazy: "true",
            },
            model: {
              value: _vm.emailSmtpPort,
              callback: function ($$v) {
                _vm.emailSmtpPort = $$v
              },
              expression: "emailSmtpPort",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "email-smtp-username",
              label: _vm.$t("admin.email_smtp_username"),
              "input-group-size": "mb-3",
              type: "text",
              lazy: "true",
            },
            model: {
              value: _vm.emailSmtpUsername,
              callback: function ($$v) {
                _vm.emailSmtpUsername = $$v
              },
              expression: "emailSmtpUsername",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "email-smtp-password",
              label: _vm.$t("admin.email_smtp_password"),
              "input-group-size": "mb-3",
              type: "password",
              lazy: "true",
              conceal: "true",
            },
            model: {
              value: _vm.emailSmtpPassword,
              callback: function ($$v) {
                _vm.emailSmtpPassword = $$v
              },
              expression: "emailSmtpPassword",
            },
          }),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  id: "email-smtp-enable-ssltls",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.isSmtpSslTlsEnabled,
                  callback: function ($$v) {
                    _vm.isSmtpSslTlsEnabled = $$v
                  },
                  expression: "isSmtpSslTlsEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(_vm._s(_vm.$t("admin.email_enable_ssltls")) + "\n    "),
          _c("br"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  id: "email-smtp-trust-cert",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.isEmailSmtpTrustCertEnabled,
                  callback: function ($$v) {
                    _vm.isEmailSmtpTrustCertEnabled = $$v
                  },
                  expression: "isEmailSmtpTrustCertEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(_vm._s(_vm.$t("admin.email_trust_cert")) + "\n  "),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: { size: "md", variant: "outline-primary" },
              on: { click: _vm.saveChanges },
            },
            [_vm._v(_vm._s(_vm.$t("message.update")))]
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.emailTestConfigurationModal",
                  modifiers: { emailTestConfigurationModal: true },
                },
              ],
              staticClass: "px-4",
              attrs: { size: "md", variant: "outline-primary" },
            },
            [_vm._v(_vm._s(_vm.$t("admin.configuration_test")))]
          ),
        ],
        1
      ),
      _c("email-test-configuration-modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }